import Typography from '@mui/material/Typography';

const Ping = () => {
  return <Typography variant="h5">OK</Typography>;
};

export default Ping;
